const DEFAULT_DOMAIN = 'outlook.office.com';
const urlDomain = `${window.location.hostname}` || DEFAULT_DOMAIN;
const bookingsUrl = `https://${urlDomain}/bookings/homepage?src=bwm`;
export default bookingsUrl;
